import * as moment from "moment/moment";

export const indexData = {
    ROOT_URL: "timeRollProcesses",

    //filter
    tableParams: {
        sortBy: [],
        sortDesc: [],
        page: 1,
    },

    month: moment().format("YYYY-MM"),
    monthForm: moment().format("YYYY-MM"),
    form: {
        processMonth: moment().format("MM"),
        processYear: moment().format("YYYY"),
        isAll: true,
    },
    leavePlans: [],
    filters: {
        code: null,
        employeeCode: null,
        employeeName: null,
        departmentName: null,
        workDate: moment().startOf("month").format("YYYY-MM-DD"),
        status: -1,
        isConfirmed: null,
        month: moment().format("MM"),
        year: moment().endOf("month").format("YYYY"),
    },
    rowCount: 0,

    departmentSearch: null,
    departments: [],

    filter: {
        menu: false,
        search: "",
        searchAttr: "name",
        searchAttrs: undefined,
        FilterAttrs: [],
        FilterOn: ["DepartmentTypeCode"],

        from: undefined,
        to: undefined,
        fromOns: [
        ],
        fromOn: "",
    },

    // VIEW DATA
    filterOpen: 1,

    //DATA TABLE
    totalItem: 0,
    items: [],
    search: "",
    options: {},
    isLoading: true,

    calDialog: false,
    unLockDialog: false,
    createDialog: false,
    dialog: false, item: null,
    dialogDelete: false,
    targetItem: undefined,

    headers: [
        { text: 'Thao tác', value: 'actions', width: 110 },
        { text: 'Mã', align: 'start', value: 'code', width: 100 },
        { text: 'Trạng thái', align: 'start', value: 'status', width: 100 },
        { text: 'Phòng', align: 'start', value: 'department.name', width: 200 },
        { text: 'Tháng', align: 'start', value: 'month', width: 200 },
        { text: 'Năm', align: 'start', value: 'year', width: 200 },
        // { text: 'Ngày áp dụng', align: 'start', value: 'date', width: 250},
        // { text: 'Số giờ', align: 'start', value: 'amount', width: 100},
        // { text: 'Người xác nhận', align: 'start', value: 'confirmedBy.name', width: 250},
        // { text: 'Ngày xác nhận', align: 'start', value: 'confirmedDate', width: 250},
    ],
}

export const mtData = {
    ROOT_URL: "monthlyTimesheets/",
    LOCKDATA_URL: "timeRollProcesses",
    DEPARTMENT_FETCH: "departmentTypes/fetch-department/",

    //filter
    tableParams: {
        sortBy: [],
        sortDesc: [],
        page: 1,
    },

    step: 1,
    progressValue: 0,
    storeLoading: false,
    excelLoading: false,
    excelUrl: "",
    excelDeptUrl: "",
    sundayCodes: [],
    month: moment().format("YYYY-MM"),
    monthForm: moment().format("YYYY-MM"),
    form: {
        processMonth: moment().format("MM"),
        processYear: moment().format("YYYY"),
        isAll: false,
    },
    leavePlans: [],
    filters: {
        code: null,
        employeeCode: null,
        employeeName: null,
        departmentName: null,
        workDate: moment().startOf("month").format("YYYY-MM-DD"),
        status: -1,
        isConfirmed: null,
        month: moment().format("MM"),
        year: moment().endOf("month").format("YYYY"),
    },
    rowCount: 0,

    departmentSearch: null,
    departments: [],

    // VIEW DATA
    filterOpen: 1,

    //DATA TABLE
    totalItem: 0,
    items: [],
    search: "",
    options: {},
    isLoading: true,

    lockWorkTime: false,
    lockDataLoading: false,
    initDialog: false,
    initLoading: false,
    saveDialog: false,
    unSaveDialog: false,
    reloadDialog: false,
    reloadLoading: false,
    createDialog: false,
    finalizeReport: false,
    excelDialog: false,
    dialog: false, item: null,
    dialogDelete: false,
    targetItem: undefined,
    sumObj: null,

    chartDataOvertime: {
        labels: ["Thường", "Ngày nghỉ", "Lễ"],
        datasets: [
            {
                label: "Số giờ",
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 2
            },
        ],
    },
    departmentHeaders: [
        { text: 'ID', align: 'start', value: 'code', width: 100 },
        { text: 'Alias', align: 'start', value: 'alias', width: 100 },
        { text: 'Tên', align: 'start', value: 'name', width: 100 },
        { text: 'Địa chỉ', align: 'start', value: 'address', width: 100 },
    ],
    selected: [],

    employeeSearch: '',
    employeeHeaders: [
        { text: 'ID', align: 'start', value: 'id', width: 100 },
        { text: 'Mã NS', align: 'start', value: 'employeeCode', width: 100 },
        { text: 'Tên NS', align: 'start', value: 'employeeName', width: 100 },
        { text: 'Ngày NV', align: 'start', value: 'hireDate', width: 100 },
        { text: 'Khối', align: 'start', value: 'departmentTypeName', width: 100 },
        { text: 'Phòng ban (store)', align: 'start', value: 'departmentName', width: 100 },
        { text: 'Team', align: 'start', value: 'teamName', width: 100 },
        { text: 'Chức vụ', align: 'start', value: 'positionName', width: 100 },
        { text: 'Chức danh', align: 'start', value: 'positionStateName', width: 100 },
        { text: 'Ca', align: 'start', value: 'shiftName', width: 100 },
        { text: 'Trạng thái', align: 'start', value: 'status', width: 100 },
        { text: 'Tạo vào', align: 'start', value: 'createdAt', width: 100 }
    ],
    employees: [],

    headers: [
        { text: 'Thao tác', value: 'actions', width: 100, align: 'center' },
        { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: 200 },
        { text: '', align: ' d-none', value: 'code' },
        { text: '', align: ' d-none', value: 'name' },
        { text: 'Phòng ban', align: 'start', value: 'department', width: 150 },
        // { text: 'Khối', align: 'start', value: 'departmentType', width: 200},
        // { text: 'Trạng thái', align: 'start', value: 'isLock', width: 100, sortable:false},
        // { text: 'Tháng', align: 'start', value: 'month', width: 100},
        // { text: 'Năm', align: 'start', value: 'year', width: 100},
    ],
    appendHeaders: [
        { text: 'Ngày công chuẩn', value: 'standardDate', width: 110, sortable: false },
        { text: 'Giờ công chuẩn', value: 'standardHour', width: 110, sortable: false },
        { text: 'Công thực tế', value: 'actualTime', width: 110, sortable: false },
        { text: 'Thiếu giờ', value: 'missingHour', width: 110, sortable: false },
        { text: 'Tăng ca chính thức', value: 'overtimeFinal', width: 110, sortable: false },
        { text: 'Làm thêm chính thức', value: 'extendFinal', width: 110, sortable: false },
        { text: 'Tổng giờ công sau bù', value: 'totalTimeFinal', width: 110, sortable: false }, //giờ công + giờ bù
        { text: 'Tổng giờ công chính thức', value: 'totalWorkTime', width: 110, sortable: false }, //giờ công + giờ bù + tăng ca + làm thêm
        { text: 'Cơm', value: 'lunch', width: 110, sortable: false },
    ],
    appendHeadersOvertime: [
        { text: 'Ngày công chuẩn', value: 'standardDate', width: 110, sortable: false },
        { text: 'Giờ công chuẩn', value: 'standardHour', width: 110, sortable: false },
        { text: 'Công thực tế', value: 'actualTime', width: 110, sortable: false },
        { text: 'Giờ làm thêm', value: 'extend', width: 110, sortable: false },

        { text: 'Giờ làm thiếu', value: 'missingHour', width: 110, sortable: false },
        { text: 'Công bù', value: 'missingCover', width: 110, sortable: false },
        { text: 'Công thiếu còn lại', value: 'missingRemain', width: 110, sortable: false },
        { text: 'Làm thêm còn lại', value: 'extendRemain', width: 110, sortable: false },

        { text: 'Tăng ca tối đa', value: 'overtimeBooking', width: 110, sortable: false },
        { text: 'Tăng ca thường', value: 'normalOvertime', width: 110, sortable: false },
        { text: 'Tăng ca ngày nghỉ', value: 'dayoffOvertime', width: 110, sortable: false },
        { text: 'Tăng ca lễ', value: 'holidayOvertime', width: 110, sortable: false },

        { text: 'Tăng ca chính thức', value: 'overtimeFinal', width: 110, sortable: false },
        { text: 'Làm thêm chính thức', value: 'extendFinal', width: 110, sortable: false },
        { text: 'Tổng giờ công sau bù', value: 'totalTimeFinal', width: 110, sortable: false },//giờ công + giờ bù
        { text: 'Cơm tăng ca', value: 'overtimeLunch', width: 110, sortable: false },
    ],
    symbols: [],
    interval: null,
    processDataLoading: false,

    //lockdata 
    lockDepartments: [],

    selectedLockDate: null,
    lockDateNote: "",
    lockedDatesArray: [],
    lockedDatesData: [],
    lockDateLoading: false,
}